"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/ImageState
 */

/**
 * @enum {number}
 */
var _default = {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
  EMPTY: 4
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2JBLElBQUksRUFBRSxDQURPO0VBRWJDLE9BQU8sRUFBRSxDQUZJO0VBR2JDLE1BQU0sRUFBRSxDQUhLO0VBSWJDLEtBQUssRUFBRSxDQUpNO0VBS2JDLEtBQUssRUFBRTtBQUxNLEMiLCJuYW1lcyI6WyJJRExFIiwiTE9BRElORyIsIkxPQURFRCIsIkVSUk9SIiwiRU1QVFkiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL0ltYWdlU3RhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=